import { EquityCompensationAssetDTO } from '../../../../../../api/useEstatePlanningExplanationQuery';
import { Beneficiaries } from '../../EditAssetForm.meta';

export interface FormValues extends EquityCompensationAssetDTO {}

export interface Body {
  Id: string;
  IncludedInEstatePlan: number;
  Beneficiaries: Beneficiaries;
}

export const formToBody = (values: FormValues): Body => {
  const {
    Id,
    IncludedInEstatePlan,
    ContingentBeneficiaries,
    PrimaryBeneficiaries,
    LastUpdated,
    TransferMethod,
  } = values;

  return {
    Id,
    IncludedInEstatePlan,
    Beneficiaries: {
      ContingentBeneficiaries: ContingentBeneficiaries || [],
      PrimaryBeneficiaries: PrimaryBeneficiaries || [],
      LastBeneficiaryUpdate: LastUpdated,
      TransferMethod:
        typeof TransferMethod === 'object' && TransferMethod !== null
          ? TransferMethod.value
          : TransferMethod,
    },
  };
};

export const EQUITY_COMPENSATION_ASSET_FORM_ID = 'equity--compensation--asset--form';
